import axios from "axios";
import {API_URL} from "../constants";
import {authHeader} from "../Utilities";

export type InsJobLog = {
    id: string,
    status: string,
    payload: any,
    created_at: string
}

export type InsJob = {
    id: string,
    type: string,
    args: any,
    logs: InsJobLog[],
    user?: { name: string },
    project?: { name: string },
    workspace?: { name: string },
}

class JobsService {
    async inspectJobs(page: number, limit: number, projectId: string | null = null): Promise<InsJob[]> {
        const response = await axios.get<InsJob[]>(
            API_URL + "/jobs",
            {
                params: {page: page, limit: limit, project_id: projectId},
                headers: authHeader()
            }
        )
        return response.data;
    }

    async terminateJob(jobId: string): Promise<boolean> {
        const res = await axios.post<boolean>(
            API_URL + "/jobs/" + jobId + "/terminate",
            {},
            {headers: authHeader()}
        );
        return res.data;
    }

    async jobCeleryStatus(jobId: string): Promise<string | null> {
        const res = await axios.get<string | null>(
            API_URL + "/jobs/" + jobId + "/celery_status",
            {headers: authHeader()}
        );
        return res.data;
    }
}

export default new JobsService();